import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import FormatColorFillIcon from '@material-ui/icons/FormatColorFill';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import { setCookie } from '../../functions/Auth';

const useStyles = makeStyles((theme) => ({
    mainLayersContainer: {
        width: '0',
        position: 'fixed',
        transition: '0.5s',
        overflowY: 'hidden',
        overflowX: 'hidden',
        paddingTop: '50px',
        height: '100%',
        zIndex: 13,
        bottom: '5px',
        borderLeft : '0px',
        backgroundColor: '#fff',
    },
    layersContainer: {
        padding: '15px',
        height: '90vh',
        '& .MuiSvgIcon-root': {
            color: '#24618E',
            fontSize: '36px',
            cursor: 'pointer',
            verticalAlign: 'middle'
        },
        '& > p': {
            margin: 0,
            '& label': {
                verticalAlign: 'middle',
                color: '#24618E',
                fontWeight: 'bold'
            }
        }
    },
    closeLayersDiv: {
        position:'absolute',
        right: '5px',
        top: '5px',
        cursor: 'pointer'
    },
    saveLayerBtn: {
        backgroundColor: '#24618E',
        color: '#fff',
        border: '0',
        borderRadius: '3px',
        fontSize: '14px',
        padding: '5px 50px',
        '&:hover': {
            backgroundColor: '#24618E',
            color: '#fff',
            boxShadow: '3px 3px 3px #bbb'
        },
        '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26)',
            border: '1px solid rgba(0, 0, 0, 0.26)',
            backgroundColor: '#fff'
        }
    },
    sortableItems: {
        listStyle: 'none',
        paddingLeft: '5px',
        width: '100%',
        height: '65vh',
        overflowY: 'auto'
    },
    footerButtons: {
        width: '100%',
        '& button:last-of-type': {
            float: 'right'
        },
        '& .MuiSvgIcon-root': {
            color: '#24618E',
            fontSize: '36px',
            cursor: 'pointer'
        }
    },
    newLayerContainer: {
        borderTop: '2px solid #24618E',
        marginTop: '25px',
        color: '#24618E',
        '& h3': {
            color: '#24618E',
            fontSize: '24px'
        }
    },
    btnIcon: {
        cursor: 'pointer',
        color: '#24618E',
        float: 'right',
        fontSize: '18px'
    },
    newLayerForm: {
        '& input': {
            width: '100%',
            marginBottom: '10px',
            border: '1px solid #ccc',
            borderRadius: '3px',
            height: '34px'
        },
        '& .MuiSvgIcon-root': {
            color: '#24618E',
            fontSize: '26px',
            marginLeft: '10px',
            verticalAlign: 'middle',
            cursor: 'pointer'
        }
    },
    okBtnContainer: {
        textAlign: 'center'
    },
    liItem: {
        // cursor: 'move',
        padding: '6px 0',
        borderBottom: '1px solid #ddd',
        listStyle: 'none',
        '& input': {
            marginRight: '10px'
        },
        '& .MuiSvgIcon-root': {
            color: '#24618E',
            fontSize: '26px',
            marginRight: '10px',
            verticalAlign: 'middle',
            cursor: 'pointer',
            float: ' right'
        }
    },
    moreOptionsContainer: {
        position: 'absolute',
        left: '300px',
        zIndex: '90000',
        background: '#fff',
        top: '120px',
        width: '250px',
        border: '1px solid #24618E',
        color: '#24618E',
        padding: '10px',
        '& ul': {
            listStyle: 'none',
            paddingLeft: '10px',
            margin: 0,
            '& .MuiSvgIcon-root': {
                verticalAlign: 'middle',
                marginRight: '5px'
            }
        },
        '& p': {
            position: 'absolute',
            right: '10px',
            top: '10px',
            margin: 0
        }
    },
    margin: {
        margin: theme.spacing(1),
    },
    textField: {
        width: '100%',
        marginTop: '8px',
        '& label': {
            top: '-5px'
        },
        '& input': {
            padding: '10px 5px'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '25px'
        }
    },
}));

const ExternalLayers = (props) => {

    const classes = useStyles();

    const [itemsLayer, setItemsLayer] = useState([]);
    const [showColors, setShowColors] = useState(false);
    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const SortableItem = SortableElement(({value, sortIndex}) => {
        return <li className={classes.liItem}> 
                <input 
                    type="checkbox" 
                    checked={value.visible} 
                    onChange={(e)=>props.handleLayerVisibility(e, sortIndex)} 
                />
                {value.layerName}

                <MoreVertIcon onClick={handleMoreOptions} />
                <FormatColorFillIcon onClick={handleColorsContainer} />
            </li>;
    });

    const SortableList = SortableContainer(({items}) => {
        return (
            <ul className={classes.sortableItems}>
            {items.map((value, index) => (
                <SortableItem 
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index} value={value} />
            ))}
            </ul>
        );
    });

    const onSortEnd = ({oldIndex, newIndex}) => {
        // reordering elements in list
        let tmpItems = [...itemsLayer];
        let element = tmpItems[oldIndex];
        tmpItems.splice(oldIndex, 1);
        tmpItems.splice(newIndex, 0, element);
        setItemsLayer(tmpItems);
        props.setCustomLayers(tmpItems);
        // reordering stored layers in array so the visibility still works
        let tmpObjs = [...props.myCustomLayers];
        let el = tmpObjs[oldIndex];
        tmpObjs.splice(oldIndex, 1);
        tmpObjs.splice(newIndex, 0, el);
        props.setMyCustomLayers(tmpObjs);
        // reordering layers in map
        props.handleReorderLayer(tmpObjs);
    };

    useEffect(() => {
        if(props.customLayers.length > 0) {
            sortLayers();
        }
    }, [props.customLayers]);

    const sortLayers = () => {
        // sort items to show in sidebar
        let arr = props.customLayers;
        arr.sort(function(a, b) {
            var x = parseInt(a["order"]); var y = parseInt(b["order"]);
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }); 
        setItemsLayer(arr);
        // set cookie for external layers
        let cookieLayers = [];
        arr.forEach(function(layer){
            cookieLayers.push({layerName: layer.layerName, visible: layer.visible})
        })
        setCookie('externalLayers',cookieLayers);
    }

    const handleColorsContainer = () => {
        setShowColors(!showColors);
    }

    const handleMoreOptions = () => {
        setShowMoreOptions(!showMoreOptions);
    }

    return (
        <>
        <div data-testid="externalLayersContainer" className={classes.mainLayersContainer} style={props.showExternalLayers ? {width:props.sidebarWidth, border: '1px solid #24618E', borderLeft: 0} : {width:'0px'}}>
            <div className={classes.layersContainer}>
            {
                !showColors ?
                <>
                    <p><ChevronLeftIcon onClick={props.handleShowLayersContainer} /> <label>External Layers</label></p>
                    {/* <SortableList items={itemsLayer} distance={5} onSortEnd={onSortEnd} /> */}
                    <ul className={classes.sortableItems} data-testid="layersList">
                        {
                            itemsLayer.map( (layer, ind) => (
                                <li className={classes.liItem}>
                                    <input 
                                        type="checkbox" 
                                        checked={layer.visible} 
                                        onChange={(e)=>props.handleLayerVisibility(e, ind)} 
                                    />
                                    {layer.layerName}
                                </li>
                            ))
                        }
                    </ul>
                    {/* {
                        !props.addingExternalLayer &&
                        <div className={classes.footerButtons}>
                            <AddCircleIcon onClick={props.handleAddLayer} />
                            <Button 
                                variant="contained"
                                // onClick={props.handleSaveLayer} 
                                className={classes.saveLayerBtn}
                                >
                                Save
                            </Button>
                        </div>
                    }
                    {
                        props.addingExternalLayer &&
                        <div className={classes.newLayerContainer}>
                            <p><FontAwesomeIcon onClick={props.handleAddLayer} icon={faTimes} className={classes.btnIcon} /></p>
                            <h3>New Layer</h3>
                            <div className={classes.newLayerForm}>
                                <input type="text" placeholder="Layer Name" onChange={(e) => props.setLayerName(e.target.value)} />
                                <input type="text" placeholder="URL" onChange={(e) => props.setLayerUrl(e.target.value)} />
                                <p onClick={handleColorsContainer}><label>Change style </label> <FormatColorFillIcon /></p>
                                <div className={classes.okBtnContainer}>
                                    <Button 
                                        className={classes.saveLayerBtn} 
                                        onClick={props.handleSaveLayer} 
                                        disabled={props.layerName!==""&&props.layerUrl!=="" ? false : true}>
                                        OK
                                    </Button>
                                </div>
                            </div>
                        </div>
                    } */}
                </>
                :
                <>
                    <p onClick={handleColorsContainer}><ChevronLeftIcon /> Back to layers</p>
                    <label>Change Style </label>

                </>
            }
        </div>
        </div>
        {
            showMoreOptions &&
            <div className={classes.moreOptionsContainer}>
                <p><FontAwesomeIcon onClick={handleMoreOptions} icon={faTimes} className={classes.btnIcon} /></p>
                <ul>
                    <li><EditIcon /> Edit</li>
                    <li><DeleteIcon /> Remove</li>
                    <li><GetAppIcon /> Export</li>
                </ul>
            </div>
        }
        </>
    )
    
}

export default ExternalLayers;